import { futureFeatureCountryCode } from 'states/persistInStorage';
import { CountryCode } from 'types/generatedSchemaTypes';
import { useAuthStore } from 'stores/authStore';

export const changeFutureAppCountryCode = (countryCode: CountryCode | null) => {
  useAuthStore.getState().setAcceptedTermsAfterFeatureCountryChange(false);
  // store the country code that user will use
  futureFeatureCountryCode(countryCode);
};
